import BpkSmallAdultIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/adult';
import BpkSmallCalendarIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/calendar';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';

import type { I18nService } from '@shared/types/i18n';
import type { Stay } from '@shared/types/utils';

import STYLES from './SearchBarHotelStay.module.scss';

import { alignIconTextBase } from '@shared/ui/common/Alignment';
import { withI18n } from '@shared/ui/contexts/i18n';
import { DATE_FORMAT } from '@shared/utils-universal/i18n/date-formats';

const AlignedSmallCalendarIconBaseText =
  alignIconTextBase(BpkSmallCalendarIcon);
const AlignedSmallAdultIconBaseText = alignIconTextBase(BpkSmallAdultIcon);

type Props = {
  i18n: I18nService;
  stay: Stay;
  preferHorizontal?: boolean;
};

const SearchBarHotelStay = ({
  i18n: { formatDate, translate, translatePlural },
  preferHorizontal,
  stay: { checkIn, checkOut, childrenAges, numberOfAdults, numberOfRooms },
}: Props) => {
  const arrayOfChildrenLen = childrenAges && childrenAges.length;
  const stayDatesLabel = translate('HotelStay_label_stayDates', {
    start_date: formatDate(checkIn, DATE_FORMAT.MEDIUM),
    end_date: formatDate(checkOut, DATE_FORMAT.MEDIUM),
  });

  const guestsLabel = translatePlural(
    'HotelStay_label_adults_',
    numberOfAdults,
    '0',
    null,
    9,
    'X',
  );

  const roomsLabel = translatePlural(
    'SelectionSummary_label_rooms',
    numberOfRooms,
    'number',
  );

  const childrenLabel =
    arrayOfChildrenLen > 0 &&
    translatePlural('HotelStay_label_children_', arrayOfChildrenLen, 'number');

  const classNames = [STYLES.SearchBarHotelStay];
  if (preferHorizontal) {
    classNames.push(STYLES['SearchBarHotelStay--horizontal']);
  }

  return (
    <div className={classNames.join(' ')}>
      {checkIn && checkOut && (
        <BpkText tagName="p" data-test-id="search-bar-stay">
          <AlignedSmallCalendarIconBaseText
            className={STYLES.SearchBarHotelStay__icon}
          />
          {stayDatesLabel}
        </BpkText>
      )}
      {!!(numberOfAdults && numberOfRooms) && (
        <BpkText tagName="p">
          <AlignedSmallAdultIconBaseText
            className={STYLES.SearchBarHotelStay__icon}
          />
          {arrayOfChildrenLen > 0 ? (
            <span>
              {guestsLabel} - {childrenLabel} - {roomsLabel}
            </span>
          ) : (
            <span>
              {guestsLabel} - {roomsLabel}
            </span>
          )}
        </BpkText>
      )}
    </div>
  );
};

export default withI18n(SearchBarHotelStay);
